/*
 * Copyright (C) 2021 DV Bern AG, Switzerland
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import {
    Directive,
    ElementRef,
    EventEmitter,
    Injector,
    Input,
    Output,
    inject
} from '@angular/core';
import {UpgradeComponent} from '@angular/upgrade/static';
import {TSBenutzerNoDetails} from '../../../models/TSBenutzerNoDetails';

@Directive({
    selector: '[dvNewUserSelect]',
    standalone: false
})
export class NewUserSelectDirective extends UpgradeComponent {
    @Input()
    public showSelectionAll: boolean;

    @Input()
    public angular2: boolean;

    @Input()
    public inputId: string;

    @Input()
    public dvUsersearch: string;

    @Input()
    public initialAll: boolean;

    @Input()
    public selectedUser: TSBenutzerNoDetails;

    @Input()
    public sachbearbeiterGemeinde: boolean;

    @Input()
    public bgAndTs: boolean;

    @Input()
    public schulamt: boolean;

    @Input()
    public userList: TSBenutzerNoDetails[];

    @Input()
    public useDefaultUserLists: boolean = true;

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output()
    public readonly userChanged: EventEmitter<{user: TSBenutzerNoDetails}> =
        new EventEmitter<{user: TSBenutzerNoDetails}>();

    public constructor() {
        const elementRef = inject(ElementRef);
        const injector = inject(Injector);

        super('dvUserselect', elementRef, injector);
    }
}
